export default "__VITE_ASSET__BbAuolsZ__"